import React from 'react';

import i18n from '@yandex-int/i18n';
import { Channel } from 'client/model/skill';
import * as skillCreationKeyset from 'i18n/SkillCreation';
import * as keyset from 'i18n/SkillsIndex';

import { AliceIcon } from './AliceIcon';
import { AutoIcon } from './AutoIcon';
import { SmartHomeIcon } from './SmartHomeIcon';
import { SmartScreenIcon } from './SmartScreenIcon';
import { TvIcon } from './TvIcon';

const t = i18n(keyset);
const tSkillCreation = i18n(skillCreationKeyset);

export const getMapChannelToAppCard = (): Record<
    Channel,
    {
        icon: React.JSX.Element | null;
        label: string;
    }
> => ({
    [Channel.AliceSkill]: {
        icon: <AliceIcon />,
        label: tSkillCreation('alice-skill'),
    },
    [Channel.AutoApp]: {
        icon: <AutoIcon />,
        label: t('auto'),
    },
    [Channel.SmartHome]: {
        icon: <SmartHomeIcon />,
        label: tSkillCreation('smart-home'),
    },
    [Channel.SmartScreenApp]: {
        icon: <SmartScreenIcon />,
        label: t('smart-screen'),
    },
    [Channel.TvApp]: {
        icon: <TvIcon />,
        label: t('tv'),
    },
    [Channel.Thereminvox]: {
        icon: null,
        label: tSkillCreation('alice-skill'),
    },
});
